module.exports = __webpack_public_path__ + "static/media/start.c7eb545b.svg";